import React, { memo } from 'react';
import { Mention } from '@atlaskit/editor-common/mention';
import { fg } from '@atlaskit/platform-feature-flags';
import { useInlineAnnotationProps } from '../../ui/annotations/element/useInlineAnnotationProps';
export default /*#__PURE__*/memo(function MentionItem(props) {
  var eventHandlers = props.eventHandlers,
    id = props.id,
    providers = props.providers,
    text = props.text,
    accessLevel = props.accessLevel,
    localId = props.localId;
  var inlineAnnotationProps = useInlineAnnotationProps(props);
  if (fg('editor_inline_comments_on_inline_nodes')) {
    return (
      /*#__PURE__*/
      // Ignored via go/ees005
      // eslint-disable-next-line react/jsx-props-no-spreading
      React.createElement("span", inlineAnnotationProps, /*#__PURE__*/React.createElement(Mention, {
        id: id,
        text: text,
        accessLevel: accessLevel,
        providers: providers,
        localId: localId,
        eventHandlers: eventHandlers && eventHandlers.mention
      }))
    );
  }
  return /*#__PURE__*/React.createElement(Mention, {
    id: id,
    text: text,
    accessLevel: accessLevel,
    providers: providers,
    localId: localId,
    eventHandlers: eventHandlers && eventHandlers.mention
  });
});